﻿//import * as bootstrap from 'bootstrap'

import Alert from '../../../node_modules/bootstrap/js/src/alert'
import Button from '../../../node_modules/bootstrap/js/src/button'
import Carousel from '../../../node_modules/bootstrap/js/src/carousel'
import Collapse from '../../../node_modules/bootstrap/js/src/collapse'
import Dropdown from '../../../node_modules/bootstrap/js/src/dropdown'
import Modal from '../../../node_modules/bootstrap/js/src/modal'
//import Offcanvas from '../../../node_modules/bootstrap/js/src/offcanvas'
import Popover from '../../../node_modules/bootstrap/js/src/popover'
//import ScrollSpy from '../../../node_modules/bootstrap/js/src/scrollspy'
//import Tab from '../../../node_modules/bootstrap/js/src/tab'
//import Toast from '../../../node_modules/bootstrap/js/src/toast'
import Tooltip from '../../../node_modules/bootstrap/js/src/tooltip'

//import Masonry from '../../../node_modules/masonry-layout/masonry'

import Filtering from "./components/Filtering"
import ImageSlider from "./components/ImageSlider"

export default {
    Alert,
    Button,
    Carousel,
    Collapse,
    //    Dropdown,
    Modal,
    //    Offcanvas,
    //    Popover,
    //    ScrollSpy,
    //    Tab,
    //    Toast,
    //    Tooltip,
    //    Masonry,
}


var cssRule1 =
    "color: rgb(1, 103, 150);" +
    "line-height: 1;" +
    "font-size: 20px;" +
    "font-weight: bold;";
var cssRule2 =
    "color: rgb(1, 103, 150);" +
    "line-height: 1;" +
    "font-size: 36px;" +
    "font-weight: bold;";
setTimeout(console.log.bind(console, "Built by"), 0);
setTimeout(console.log.bind(console, "%ccoastal\n%cC#DE", cssRule1, cssRule2), 0);
setTimeout(console.log.bind(console, "Visit: https://coastal-code.com/"), 0);
setTimeout(console.log.bind(console, "Email: info@coastal-code.com"), 0);
